import { MultiRowSelectOptionsConfig, SelectionState } from "../types"
import { forwardRef } from "react"
import { TableSelectAllOptionProps } from "./types"

const TableRowSelectOption = forwardRef<HTMLButtonElement, TableSelectAllOptionProps>(
  ({ onClick, children, onRequestClose, ...rest }, ref) => {
    return (
      <li>
        <button
          {...rest}
          className="w-full px-2 py-1 text-start hover:bg-gray-100 focus:bg-gray-100"
          onClick={e => {
            onClick?.(e)
            onRequestClose()
          }}
          ref={ref}
        >
          {children}
        </button>
      </li>
    )
  },
)

export function TableRowSelectOptionList({
  onRequestClose,
  onSelect,
  multiRowSelectOptionsConfig,
}: {
  onRequestClose: () => void
  onSelect: (key: SelectionState) => void
  multiRowSelectOptionsConfig: MultiRowSelectOptionsConfig
}) {
  return (
    <ul className="text-xs">
      {multiRowSelectOptionsConfig.map(({ label, key, dataAnalyticsName }) => (
        <TableRowSelectOption
          onRequestClose={onRequestClose}
          key={key}
          onClick={() => onSelect(key)}
          data-analytics-name={dataAnalyticsName}
        >
          {label}
        </TableRowSelectOption>
      ))}
    </ul>
  )
}
